import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import { useState, useEffect } from "react";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Sales from "./pages/Sales";
import Reports from "./pages/Reports";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Categories from "./pages/Categories";
import UserGuide from "./pages/UserGuide";
import Feedback from "./pages/Feedback";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import Subscription from "./pages/Subscription";
import SubscriptionVerify from "./pages/SubscriptionVerify";
import AdminDashboard from "./pages/AdminDashboard";
import TeamMembers from "./pages/TeamMembers";
import JoinTeam from "./pages/JoinTeam";
import SubscriptionPopup from "./components/SubscriptionPopup";
import WhatsAppButton from "./components/WhatsAppButton";
import BottomNav from "./components/BottomNav";
import Settings from "./pages/Settings";
import { syncPendingOperations  } from "./utils/syncQueue";
import Expenses from "./pages/Expenses";
import Debts from "./pages/Debts";

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    fetch(`https://stocksense-backend-g1kp.onrender.com/cron/unsubscribe?token=${token}`)
      .then(res => res.json())
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);
  
   useEffect(() => {
  window.addEventListener("online", syncPendingOperations );
  return () => window.removeEventListener("online", syncPendingOperations );
}, []);

  return (
    <div style={{
      minHeight: "100vh", background: "#0a0f0f",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "32px", fontFamily: "inherit",
    }}>
      <div style={{
        background: "#0f1a1a", border: "1px solid #1e3333",
        borderRadius: "16px", padding: "48px 32px",
        maxWidth: "400px", width: "100%", textAlign: "center",
      }}>
        {status === "loading" && <p style={{ color: "#5a8a8a" }}>Processing...</p>}
        {status === "success" && (
          <>
            <p style={{ fontSize: "48px" }}>✅</p>
            <h2 style={{ color: "#e8f5f5", marginBottom: "12px" }}>Unsubscribed</h2>
            <p style={{ color: "#5a8a8a", lineHeight: "1.6" }}>
              You will no longer receive weekly reports from MartSense.
            </p>
            <a href="/" style={{
              display: "inline-block", marginTop: "24px",
              color: "#2ec4b6", textDecoration: "none", fontWeight: "600",
            }}>← Back to App</a>
          </>
        )}
        {(status === "invalid" || status === "error") && (
          <>
            <p style={{ fontSize: "48px" }}>❌</p>
            <h2 style={{ color: "#e8f5f5", marginBottom: "12px" }}>Invalid Link</h2>
            <p style={{ color: "#5a8a8a" }}>This unsubscribe link is not valid.</p>
          </>
        )}
      </div>
    </div>
  );
}
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
          <Route path="/categories" element={<PrivateRoute><Categories /></PrivateRoute>} />
          <Route path="/sales" element={<PrivateRoute><Sales /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
          <Route path="/guide" element={<PrivateRoute><UserGuide /></PrivateRoute>} />
          <Route path="/feedback" element={<PrivateRoute><Feedback /></PrivateRoute>} />
          <Route path="/subscription" element={<PrivateRoute><Subscription /></PrivateRoute>} />
          <Route path="/subscription/verify" element={<PrivateRoute><SubscriptionVerify /></PrivateRoute>} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/team" element={<PrivateRoute><TeamMembers /></PrivateRoute>} />
          <Route path="/join" element={<JoinTeam />} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/expenses" element={<PrivateRoute><Expenses /></PrivateRoute>} />
          <Route path="/debts" element={<Debts />} />
        </Routes>
        <SubscriptionPopup />
        <WhatsAppButton />
        <PWAInstallPrompt />
        <BottomNav />
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;